"use client";
'use strict';

var React = require('react');
var Provider = require('./Provider.js');

function useRollbar() {
  var context = React.useContext(Provider.Context);
  return Provider.getRollbarFromContext(context);
}

exports.useRollbar = useRollbar;
//# sourceMappingURL=useRollbar.js.map
